import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    actionName: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Name of the remove background action. */
            actionName: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRemoveBackgroundAction.actionName?c=34dwjo0zjm2ot", defaultMessage: "Remove Background" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
